/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 14:59:13 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { Toolbar } from 'react-admin';
import { toolbarStyles } from 'styles';

const SanitizedChildren = ({ children }) => {
  return children;
};

const CustomToolbar = props => {
  const { hasList, hasShow, hasEdit, hasCreate, ...rest } = props;
  const classes = toolbarStyles();
  return (
    <Toolbar className={classes.root} {...rest}>
      <SanitizedChildren {...rest} />
    </Toolbar>
  );
};

export default CustomToolbar;
